const categories = {
    all: 'All',
    MAN_TSHIRT: "Unisex/Men's T-Shirts",
    MAN_HOODIES: "Men's Hoodies",
    MAN_SWEATSHIRT: "Men's Sweatshirts",
    MAN_LONGLEEVES: "Men's Longleves",
    MAN_TANKTOP: "Men's Tank Tops",
    TROUSERS_UNDERWEAR: 'Trousers & Underwear',
    WOMAN_TSHIRT: "Women's T-Shirts",
    WOMAN_TANKTOP: "Women's Tank Tops",
    WOMAN_SWEATSHIRT: "Women's Sweatshirts",
    KINDER_TSHIRT: 'Kids T-Shirts',
    OTHER: 'Other stuff',
    MUG: 'Cups & Glasses',
    HOME: 'Home & Living',
    MAN_TROUSERS_AND_SHORTS: "Men's Trousers & Shorts",
    MAN_UNDERWEAR: "Men's Underwear",
    KIDS_TSHIRT: 'Kids T-Shirts',
    KIDS_HOODIE: 'Kids Hoodies',
    KIDS_SWEATSHIRT: 'Kids Sweatshirts',
    KIDS_OTHER: 'Kids Other',
    POSTER_AND_CANVAS: 'Poster & Canvas',
    GLASS_DISPLAY: 'Glass Displays',
    STUFFED_ANIMAL: 'Stuffed Animals',
    PILLOW: 'Pillows',
    DOOR_MAT: 'Door Mats',
    ORNAMENT: 'Ornaments',
    HEADWEAR: 'Headwear',
    BAG: 'Bags',
    SOCKS: 'Socks',
    PHONE_CASE: 'Phone Cases',
    KEY_CHARM: 'Key Charms',
    OTHER_ACCESSORIES: 'Other Accessories',
    BESTSELLER: 'Bestseller',
    NEW: 'New',
    SUMMER: 'Summer',
    OVERSIZED: 'Oversized',
    ORGANIC: 'Organic',
    WINTER: 'Winter',
    MAN_SWIMWEAR: "Men's Swimwear",
    MAN_SPORTSWEAR: "Men's Sportswear",
    WOMAN_SPORTSWEAR: "Women's Sportswear",
    FOOTWEAR: 'Footwear and sandals',
    Frauen: 'Women',
    'Unisex / Männer': 'Unisex / Men',
    Sonstiges: 'Other stuff',
    Kinder: 'Kids & Babies',
    'Home & Living': 'Home & Living',
    Accessoires: 'Accessories',
    Bestseller: 'Bestseller',
    Neuheiten: 'New products',
    'Für den Sommer': 'Summer collection',
    Oversized: 'Oversized',
    Organic: 'Organic',
    Winterkollektion: 'Winter collection',
    Eigenmarken: 'By MarketPrint',
    MP_ORIGINALS: 'By MarketPrint',
};

export default categories;
